import { Injectable } from '@angular/core';
import { AuthSelectors } from '@app/store/auth/auth.selectors';
import { Store } from '@ngxs/store';
import { catchError, EMPTY, mergeMap, Observable, of } from 'rxjs';
import { ApiService } from './api.service';
import { DateService } from './date.service';

interface NoteGps {
  objkbn: string;
  objcd: string;
  odrunitcd: string;
  odrseccd: string;
  odrteamcd: string;
  odrjobcd: string;
  upddate: Date;
}

@Injectable({
  providedIn: 'root',
})
export class GpsService {
  constructor(
    private store: Store,
    private dateService: DateService,
    private apiService: ApiService
  ) { }

  gpsLocationGet(): Observable<{ latitude: number, longitude: number }> {
    if (!navigator.geolocation) {
      console.log('Geolocation is not supported by your browser');
      return EMPTY;
    }
    return this.getLocation().pipe(
      mergeMap((position) => {
        const { latitude, longitude } = position.coords;
        return of({ latitude, longitude });
      }));
  }

  setNoteGps({
    objkbn,
    objcd,
    odrunitcd,
    odrseccd,
    odrteamcd,
    odrjobcd,
    upddate,
  }: NoteGps): Observable<void | boolean> {
    // if return false --> false to get coordinates
    if (!navigator.geolocation) {
      console.log('Geolocation is not supported by your browser');
      return of(false);
    }

    const profile = this.store.selectSnapshot(AuthSelectors.profile);

    return this.gpsLocationGet().pipe(
      mergeMap((position) => {
        const { latitude, longitude } = position;
        if (!latitude || !longitude || isNaN(latitude) || isNaN(longitude)) return of(false);
        // meaningful coordinate got !
        const time = this.dateService.format(upddate, 'yyyy/MM/dd HH:mm');
        const payload = {
          objkbn,
          objcd,
          odrstfcd: profile?.staffCode,
          odrstfnm: profile?.fullName,
          odrunitcd,
          odrseccd,
          odrteamcd,
          odrjobcd,
          time,
          latitude: String(latitude),
          longitude: String(longitude),
          label: 'サービス実施',
        };

        return this.apiService.setNoteGpsUpate(payload);
      }),
      catchError((error: GeolocationPositionError) => {
        // console.log(error);
        if (error?.code === GeolocationPositionError.PERMISSION_DENIED ||
          error?.code === GeolocationPositionError.POSITION_UNAVAILABLE
        ) return of(true);
        return of(false);
      })
    );
  }

  private getLocation(): Observable<GeolocationPosition> {
    return new Observable((observer) => {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          observer.next(position);
          observer.complete();
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }
}
